import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { addListInBoard } from '../../actions/userActions';
import { withRouter } from 'react-router-dom';
import $ from 'jquery';
import './EditListModal.css'; // Import your custom CSS file for styling


const EditListModal = ({ addListInBoard, auth, errors, getData, listData, board }) => {

    const [selectedLists, setSelectedLists] = useState([]);
    useEffect(() => {
        const selectedNamesAndIds = listData
          .filter((item) => item.status === true)
          .map((item) => ({ id: item.id, name: item.name }));
        setSelectedLists(selectedNamesAndIds);
      
      }, [listData]);
    

    const hideModal = () => {
        $('#edit-list-modal').modal('hide');
    };

    const onEditList = (e) => {
        e.preventDefault();
        addListInBoard(selectedLists, board, hideModal);
    };


      const handleCheckboxChange = (listName, listId) => {
        setSelectedLists((prevSelectedLists) => {
            const isSelected = prevSelectedLists.some((item) => item.name === listName);
    
            if (isSelected) {
                const updatedLists = prevSelectedLists.filter((item) => item.name !== listName);
                return updatedLists;
            } else {
                const updatedLists = [...prevSelectedLists, { name: listName, id: listId }];
                return updatedLists;
            }
        });
    };
    

    return (
        <div>
            <div className="modal fade" id="edit-list-modal" data-reset="true">
                <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h4 className="modal-title">Add List</h4>
                        <button type="button" className="close" data-dismiss="modal">
                        &times;
                        </button>
                    </div>
                    <div className="modal-body">
                        <form noValidate onSubmit={onEditList} id="edit-list">
                            {listData.map((list) => {
                                return (
                                    <div key={list.id} className="form-check mb-3 checkbox-container">
                                        <input
                                        type="checkbox"
                                        id={`list-${list.name}`}
                                        className="form-check-input custom-checkbox"
                                        checked={selectedLists.some((item) => item.name === list.name)}

                                        onChange={() => handleCheckboxChange(list.name, list.id)}
                                        />
                                        <label htmlFor={`list-${list.name}`} className="form-check-label ml-2">
                                        {list.name}
                                        </label>
                                    </div>
                                )
                            })}
                        </form>
                    </div>
                    <div className="modal-footer">
                        <button
                        type="button"
                        className="btn btn-secondary"
                        data-dismiss="modal"
                        >
                        Close
                        </button>
                        <button form="edit-list" type="submit" className="btn btn-primary">
                        Add List
                        </button>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

EditListModal.propTypes = {
    addListInBoard: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired,
    getData: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    auth: state.auth,
    errors: state.errors,
});

export default connect(mapStateToProps, { addListInBoard })(
    withRouter(EditListModal)
);
